export default "__VITE_ASSET__YwDYEqZw__"